import LoginButton from "components/molecules/LoginButton";
import {
    getLeadHubspotAuthURL,
    getLeadHubspotAuthURLWithModule,
    postLeadCreateHubspot,
} from "helpers/leads/leadDestinations/getDestinations";
import React, { useState } from "react";

interface HubspotLeadCRMProps {
    onStoreSuccess: (data: any) => void;
    hubspotName: string | null;
    selectedModule: string | null;
}

const HubspotLeadCRM = ({
    onStoreSuccess,
    hubspotName,
    selectedModule,
}: HubspotLeadCRMProps) => {
    const [isLoading, setIsLoading] = useState(false);
    const onLoginSuccess = async ({ code }: { code: string }) => {
        setIsLoading(true);
        const response = await postLeadCreateHubspot({
            code,
            name: hubspotName,
            module: selectedModule,
        });
        if (response.status) {
            onStoreSuccess(response.data);
        }
        setIsLoading(false);
    };
    const getAuthURL = async () => {
        const response = selectedModule 
            ? await getLeadHubspotAuthURLWithModule(selectedModule)
            : await getLeadHubspotAuthURL();
        return response.status ? response?.data?.url : null;
    };

    return (
        <div className="position-relative overflow-hidden z-1">
            <LoginButton
                code="hubspot"
                getAuthUrl={getAuthURL}
                paramNames={["code"]}
                onSuccess={onLoginSuccess}
                dataTransform={(params) => ({
                    code: params.code,
                    source_type: "hub",
                })}
                logoSrc="/assets/images/hubspot.png"
                logoStyle={{ borderRadius: "50%" }}
                buttonText="Connect with HubSpot"
                disabled={isLoading || !hubspotName || !selectedModule}
                isLoadingExternal={isLoading}
            />
        </div>
    );
};

export default HubspotLeadCRM;
